// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hide the default upload icon */
:host ::ng-deep .p-fileupload-choose .p-button-icon {
  display: none !important;
}

:host ::ng-deep .p-fileupload-choose .p-button-label {
  margin-left: 0 !important;
}

:root {
  --primary: #04828E;
  --secondary: #008DD2;
}

.bank-card {
  background: linear-gradient(135deg, #ffffff, #f4fbfc);
  border-radius: 16px;
  padding: 1rem;
  height: 100%;
  border-left: 5px solid var(--primary);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  transition: all 0.25s ease;
}

.bank-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.12);
}

.bank-card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
}

.account-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--primary);
}

.bank-name {
  font-size: 0.8rem;
  color: var(--secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bank-card-body .info-row {
  display: flex;
  justify-content: space-between;
  padding: 0.35rem 0;
  font-size: 0.85rem;
}

.bank-card-body .info-row span {
  color: #6c757d;
}

.bank-card-body .info-row strong {
  color: #212529;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/payment/payment.component.scss"],"names":[],"mappings":"AAAA,iCAAA;AACA;EACI,wBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,qDAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,qCAAA;EACA,0CAAA;EACA,0BAAA;AACJ;;AAEA;EACI,2BAAA;EACA,2CAAA;AACJ;;AAEA;EACI,4CAAA;EACA,uBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;AACJ","sourcesContent":["/* Hide the default upload icon */\n:host ::ng-deep .p-fileupload-choose .p-button-icon {\n    display: none !important;\n}\n\n:host ::ng-deep .p-fileupload-choose .p-button-label {\n    margin-left: 0 !important;\n}\n\n:root {\n    --primary: #04828E;\n    --secondary: #008DD2;\n}\n\n.bank-card {\n    background: linear-gradient(135deg, #ffffff, #f4fbfc);\n    border-radius: 16px;\n    padding: 1rem;\n    height: 100%;\n    border-left: 5px solid var(--primary);\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n    transition: all 0.25s ease;\n}\n\n.bank-card:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.12);\n}\n\n.bank-card-header {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    padding-bottom: 0.75rem;\n    margin-bottom: 0.75rem;\n}\n\n.account-name {\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--primary);\n}\n\n.bank-name {\n    font-size: 0.8rem;\n    color: var(--secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.bank-card-body .info-row {\n    display: flex;\n    justify-content: space-between;\n    padding: 0.35rem 0;\n    font-size: 0.85rem;\n}\n\n.bank-card-body .info-row span {\n    color: #6c757d;\n}\n\n.bank-card-body .info-row strong {\n    color: #212529;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
